import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { login } from '../api/client';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { ThemeToggle } from '../components/ThemeToggle';

/** Login gate shown in API mode when there is no session. */
export function LoginScreen() {
  const { t } = useTranslation();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  function reloadIntoApp() {
    window.location.assign('/');
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await login(identifier, password);
      if (res.sessionId) {
        reloadIntoApp();
        return;
      }
      setError(t('login.failed'));
    } catch {
      setError(t('login.failed'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="login__panel">
        <div className="login__topbar">
          <LanguageSwitcher />
          <ThemeToggle compact />
        </div>

        <div className="login__card card">
          <div className="login__brand">
            <img src="/oracle-logo.png" alt="Oracle" className="shell__logo" />
            <div>
              <div className="shell__brand-title">{t('app.title')}</div>
              <div className="shell__brand-sub">{t('app.subtitle')}</div>
            </div>
          </div>

          <form onSubmit={submit}>
            <label className="field">
              <span className="field__label">{t('login.identifier')}</span>
              <input
                className="input"
                value={identifier}
                onChange={(ev) => setIdentifier(ev.target.value)}
                autoComplete="username"
              />
            </label>
            <label className="field">
              <span className="field__label">{t('password.label')}</span>
              <input
                className="input"
                type="password"
                value={password}
                onChange={(ev) => setPassword(ev.target.value)}
                autoComplete="current-password"
              />
            </label>
            <button
              type="submit"
              className="btn btn--primary"
              disabled={busy || !identifier || !password}
            >
              {t('login.signIn')}
            </button>
          </form>

          {error && <p className="form-error">{error}</p>}
        </div>
      </div>
    </div>
  );
}
